import Modal from "../shared/Modal";
import "./ModalApplicationNotConnected.css";

type ModalApplicationNotConnectedProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  appName: string;
};

const ModalApplicationNotConnected = ({
  isOpen,
  onClose,
  onContinue,
  appName,
}: ModalApplicationNotConnectedProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-application-not-connected">
          <div className="modal-collection-application-not-connected-title">
            Please Connect Your {appName} Account
          </div>

          <div className="modal-collection-application-not-connected-content">
            This feature requires that you connect your {appName} account. You
            can do this from the Settings page.
          </div>

          <div className="modal-collection-application-not-connected-footer">
            <div className="modal-collection-application-not-connected-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Continue to Settings
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalApplicationNotConnected;
